export default {
  setdaysToDate (state: {[key:string]: number}, val: number) {
    state.daysToDate = val
  },
  setDisplayYear (state: any, year: string) {
    state.displayYear = year
  },
  setMidDrainageModalFlag (state: {[key: string]: any}, flag: boolean) {
    state.midDrainageModalFlag = flag
  },
  setDviGraphModalFlag (state: {[key: string]: any}, flag: boolean) {
    state.dviGraphModalFlag = flag
  },
  setStageListModalFlag (state: {[key: string]: any}, flag: boolean) {
    state.stageListModalFlag = flag
  },
  setImgDate (state: any, date: number) {
    state.imgDate = date
  },
  setMainImgId (state: any, id: number) {
    state.imgId = id
  },
  setMaxDate (state: any, date: string) {
    state.maxDate = date
  },
  setStageData (state: any, data: {[key: string]: any}) {
    state.stageData = data
  },
  setGraphRange (state: any, data: number[]) {
    state.graphRange = data
  }
}
